export default ['uniswap']